import { useCallback } from 'react';

import { useTelemetry } from '@order/Telemetry';

import type { AddressForm } from '../../address.config';

export const useAddressFormTelemetry = () => {
  const { track } = useTelemetry();

  const trackSave = useCallback(
    (data: AddressForm) => {
      track('addresses.save', {
        dropoffMethod: data.deliveryPreference?.toLowerCase() ?? '',
        type: ['home', 'work'].includes(data.name?.toLowerCase() ?? '')
          ? (data.name?.toLowerCase() ?? 'custom')
          : 'custom',
      });
    },
    [track],
  );

  const trackDelete = useCallback(() => {
    track('addresses.remove');
  }, [track]);

  const trackFail = useCallback(
    (userError?: string, systemError?: string) => {
      track('addresses.save_failed', { userError, systemError });
    },
    [track],
  );

  return {
    trackSave,
    trackDelete,
    trackFail,
  };
};
